import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DynamicDropdown from "components/Elements/DynamicDropdown";
import { useFilters } from "../FilterContext";
import { useFilterInitialization } from "./hooks/useFilterInitialization";
import { SHOW_ALL_OPTION } from "../constants";

// Audit History record type groups (EMI3-1460). The ids are the API taxonomy
// keys; labels use the tenant's custom captions.
// Labels are the Site Terminology keys - the server applies the tenant's
// overrides, so t() gives both their wording and the active locale
const buildEntityTypeOptions = (t) => [
	SHOW_ALL_OPTION,
	{ id: "service", name: t("entity.service") },
	{ id: "defect", name: t("entity.defect") },
	{ id: "feedback", name: t("entity.feedback") },
	{ id: "userAccess", name: t("label.userAccess") },
];

const toParams = (item) => ({ entityTypes: item.id ? [item.id] : [] });

export const EntityTypeFilter = () => {
	const { filterValues, updateFilter } = useFilters();
	const { t } = useTranslation();

	const options = useMemo(() => buildEntityTypeOptions(t), [t]);

	useFilterInitialization("entityType", options, {
		waitForData: false,
		getDefaultValue: () => SHOW_ALL_OPTION,
		getParams: toParams,
		getReportParams: toParams,
	});

	if (!filterValues.entityType) {
		return null;
	}

	const handleChange = (item) => {
		updateFilter("entityType", item, toParams(item), true, toParams(item));
	};

	return (
		<Grid item lg={3} md={6} xs={12}>
			<DynamicDropdown
				dataSource={options}
				columns={[{ name: "name", id: 1 }]}
				showHeader={false}
				width="100%"
				placeholder={t("placeholder.selectRecordType")}
				onChange={handleChange}
				selectdValueToshow="name"
				selectedValue={filterValues.entityType?.value}
				label={t("label.filterByRecordType")}
				icon={<FilterListIcon style={{ color: "rgb(48, 122, 215)" }} />}
				required={false}
				showBorderColor
			/>
		</Grid>
	);
};
